/**
 * Error Messages
 *
 * Why: Consistent,user-friendly error messages
 * What: Human-readable messages for each error type
 * Benefits:
 *      - Consistent UX across the application
 *      - Easy to update/translate messages
 *      - Separate technical codes from user messages
 *
 * Notes: These should be user-friendly, not technical
 * Technical details go in logs, not shown to user
 */

export const ERROR_MESSAGES = {
  // ============================================
  // Network Errors
  // ============================================

  NETWORK_ERROR:
    "Unable to connect to the server. Please check your internet connection and try again.",

  NETWORK_TIMEOUT:
    "The request is taking too long. Please check your connection and try again.",

  NETWORK_CANCELLED: "The request was cancelled.",

  CONNECTION_REFUSED:
    "Unable to reach the server. Please try again in a few moments.",

  // ============================================
  // Authentication Errors
  // ============================================

  UNAUTHORIZED: "Your session has expired. Please log in again.",

  // ============================================
  // Authorization Errors
  // ============================================

  FORBIDDEN: "You don't have permission to perform this action.",

  INSUFFICIENT_PERMISSIONS:
    "You don't have the required permissions for this action.",

  ACCESS_DENIED: "Access to this resource has been denied.",

  // ============================================
  // Validation Errors
  // ============================================

  VALIDATION_ERROR: "Please check your input and try again.",

  INVALID_INPUT:
    "The information you entered is invalid. Please check and try again.",

  REQUIRED_FIELD: "This field is required.",

  INVALID_EMAIL: "Please enter a valid email address.",

  PASSWORD_TOO_SHORT: "Password must be at least 8 characters long.",
  // ============================================
  // Client Errors
  // ============================================

  BAD_REQUEST: "The request could not be processed. Please try again.",

  NOT_FOUND: "The requested resource was not found.",

  CONFLICT:
    "This action conflicts with the current state. Please refresh and try again.",

  PAYLOAD_TOO_LARGE: "The file or data you are trying to upload is too large.",

  // ============================================
  // Rate Limiting
  // ============================================

  RATE_LIMIT_EXCEEDED:
    "You've made too many requests. Please wait a moment and try again.",

  RATE_LIMIT_DAILY:
    "You've reached your daily limit. Please try again tomorrow.",

  // ============================================
  // Server Errors
  // ============================================

  SERVER_ERROR: "Something went wrong on our end. Please try again later.",

  SERVICE_UNAVAILABLE:
    "The service is temporarily unavailable. Please try again later.",

  MAINTENANCE: "We're currently performing maintenance. Please try again soon.",

  // ============================================
  // Generic
  // ============================================

  UNKNOWN_ERROR: "An unexpected error occurred. Please try again.",

  GENERIC_ERROR: "Something went wrong. Please try again.",

  RETRY_LATER: "Please try again in a few moments.",
} as const;

export type ErrorMessageKey = keyof typeof ERROR_MESSAGES;
